var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.showBulletins),function(bulletin,i){return _c('div',{key:i},[(bulletin[_vm.$i18n.locale])?_c('v-alert',{attrs:{"value":true,"type":bulletin.alertType,"outline":""},domProps:{"innerHTML":_vm._s(bulletin[_vm.$i18n.locale])}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }